import React from "react";
import TooltipInfo from "../tooltip-info";

const FormSelect = (props) => {
  const {
    label,
    valueSelected,
    options,
    onChange,
    labelInfo,
    noteInfo,
    className,
    ...rest
  } = props;

  const renderLabel = React.useCallback(() => {
    if (!label) return null;
    return (
      <div className="booking-form__label">
        <label className="form-label user-select-none d-flex align-items-center">
          {label}
          {labelInfo && <TooltipInfo title={labelInfo} />}
        </label>
      </div>
    );
  }, [label]);

  const handleSelect = (e) => {
    const { value } = e.target;
    onChange?.(value);
  };

  return (
    <div className={`booking-form__row ${className}`}>
      {renderLabel()}
      <div className="booking-form__control">
        <div className="form-switch">
          <select
            className="form-select"
            onChange={handleSelect}
            value={valueSelected}
            {...rest}
          >
            {options.map((option, index) => (
              <option value={option.value} key={`${option.label}_${index}`}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
        {noteInfo && (
          <p
            className="text-xs mt-2"
            style={{
              fontSize: "12px",
              color: "#777",
              lineHeight: "1.3",
            }}
          >
            {noteInfo}
          </p>
        )}
      </div>
    </div>
  );
};

export default React.memo(FormSelect);
